import type { ChatMessage } from '@wundo/shared/chat.ts';
import type { ChatActivityStep } from '@wundo/ui';

type Steps = readonly ChatActivityStep[];

/**
 * The steps above one message: the ones followed live this session, or else the
 * ones the reply was stored with, which is how a conversation read back shows
 * what it showed while it ran.
 */
export function chatMessageActivity(
  message: ChatMessage,
  pinned: ReadonlyMap<string, Steps> | undefined,
): Steps {
  const live = pinned?.get(message.id);
  if (live && live.length > 0) {
    return live;
  }

  return (message.activity ?? []).map((step) => ({
    id: step.step_id,
    text: step.text,
    state: step.phase,
    icon: step.icon,
    ...(step.detail ? { detail: step.detail } : {}),
    ...(step.link ? { link: step.link } : {}),
  }));
}
